/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenMonitorIcon24Regular = forwardRef('TechScreenMonitorIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 3.25A3.75 3.75 0 0 0 2.25 7v7A3.75 3.75 0 0 0 6 17.75h3.25v2.5H7a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5h-2.25v-2.5H18A3.75 3.75 0 0 0 21.75 14V7A3.75 3.75 0 0 0 18 3.25H6Zm12 13A2.25 2.25 0 0 0 20.25 14V7A2.25 2.25 0 0 0 18 4.75H6A2.25 2.25 0 0 0 3.75 7v7A2.25 2.25 0 0 0 6 16.25h12Zm-4.75 1.5v2.5h-2.5v-2.5h2.5Z" })));
});
